import React, { useState } from 'react';

export default function StepStelle({ wert = {}, onChange, onWeiter }) {
  const [modalOffen, setModalOffen] = useState(false);
  const [modus, setModus] = useState('link');
  const [url, setUrl] = useState('');
  const [text, setText] = useState('');

  const gespeichert = wert?.inhalt;

  function bestaetigen() {
    const inhalt = modus === 'link' ? url.trim() : text.trim();
    if (!inhalt) return;
    onChange({ modus, inhalt });
    setModalOffen(false);
    setTimeout(() => onWeiter?.(), 80);
  }

  function oeffnen() {
    // Vorherigen Wert vorbefüllen
    if (wert?.modus === 'link') setUrl(wert.inhalt ?? '');
    if (wert?.modus === 'text') { setModus('text'); setText(wert.inhalt ?? ''); }
    setModalOffen(true);
  }

  const kannBestaetigen = modus === 'link' ? url.trim().length > 0 : text.trim().length > 0;

  return (
    <div className="ob-step-enter">
      {/* Stellenlink-Karte */}
      <button
        type="button"
        className={`ob-job-choice${gespeichert ? ' ob-job-choice--aktiv' : ''}`}
        onClick={oeffnen}
      >
        <span className="ob-job-choice__eyebrow">{gespeichert ? 'GESPEICHERT' : 'SCHNELLSTER START'}</span>
        <strong>
          {gespeichert
            ? (wert.inhalt.length > 52 ? wert.inhalt.slice(0, 52) + '…' : wert.inhalt)
            : 'Stellenlink einfügen'}
        </strong>
        <span>{gespeichert ? 'Klicken zum Ändern.' : 'LinkedIn, StepStone, Indeed oder Karriereseite.'}</span>
      </button>

      {/* Später machen */}
      <button
        type="button"
        className={`ob-job-choice ob-job-choice--spaeter${wert?.modus === 'spaeter' ? ' ob-job-choice--aktiv' : ''}`}
        onClick={() => onChange({ modus: 'spaeter', inhalt: '' })}
      >
        <span className="ob-job-choice__eyebrow">Kein Druck</span>
        <strong>Später machen</strong>
        <span>Du kannst im Dashboard jederzeit starten.</span>
      </button>

      {/* Modal */}
      {modalOffen && (
        <div className="ob-stelle-modal-backdrop" onClick={e => { if (e.target === e.currentTarget) setModalOffen(false); }}>
          <div className="ob-stelle-modal">
            <button
              type="button"
              className="ob-stelle-modal-close"
              onClick={() => setModalOffen(false)}
              aria-label="Schließen"
            >
              ✕
            </button>
            <div className="ob-stelle-modal-head">
              <span className="ob-stelle-modal-eyebrow">Neue Stelle</span>
              <h3 className="ob-stelle-modal-title">
                {modus === 'link' ? 'Link zur Stellenanzeige' : 'Stellenbeschreibung einfügen'}
              </h3>
              <p className="ob-stelle-modal-sub">
                {modus === 'link'
                  ? 'Füge zuerst den Link ein. CVFlow liest die Anzeige aus und bereitet die Analyse vor.'
                  : 'Nutze den Volltext, wenn kein stabiler Link verfügbar ist.'}
              </p>
            </div>

            {modus === 'link' ? (
              <input
                className="ob-stelle-modal-input"
                type="url"
                value={url}
                onChange={e => setUrl(e.target.value)}
                placeholder="https://unternehmen.de/jobs/..."
                autoFocus
                onKeyDown={e => { if (e.key === 'Enter' && kannBestaetigen) bestaetigen(); }}
              />
            ) : (
              <textarea
                className="ob-stelle-modal-textarea"
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="Füge hier die vollständige Stellenbeschreibung ein..."
                autoFocus
                rows={5}
              />
            )}

            <p className="ob-stelle-modal-tipp">
              {modus === 'link'
                ? 'Tipp: URLs von Jobbörsen oder Karriereseiten funktionieren am besten.'
                : 'Tipp: Je vollständiger der Text, desto präziser werden CV und Anschreiben.'}
            </p>

            {/* Quelle wählen */}
            <div className="ob-stelle-modal-quellen">
              <span className="ob-stelle-modal-quellen-label">QUELLE WÄHLEN</span>
              <div className="ob-stelle-modal-quellen-grid">
                <button
                  type="button"
                  className={`ob-stelle-quelle${modus === 'link' ? ' ob-stelle-quelle--aktiv' : ''}`}
                  onClick={() => setModus('link')}
                >
                  <span className="ob-stelle-quelle-icon">🔗</span>
                  <span>
                    <strong>URL verwenden</strong>
                    <small>Empfohlener Start</small>
                  </span>
                </button>
                <button
                  type="button"
                  className={`ob-stelle-quelle${modus === 'text' ? ' ob-stelle-quelle--aktiv' : ''}`}
                  onClick={() => setModus('text')}
                >
                  <span className="ob-stelle-quelle-icon">📄</span>
                  <span>
                    <strong>Text einfügen</strong>
                    <small>Für kopierte Anzeigen</small>
                  </span>
                </button>
              </div>
            </div>

            <button
              type="button"
              className={`ob-stelle-modal-btn${!kannBestaetigen ? ' ob-stelle-modal-btn--disabled' : ''}`}
              onClick={bestaetigen}
              disabled={!kannBestaetigen}
            >
              Weiter →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
